// General formatting functions
import { isEmpty, compact } from 'lodash'

const normalizeDate = (date) => (
  (date instanceof Date) ? date : new Date(date)
)


const formatDate = (date, dateOptions = {}, toUTC = true) => {
  date = normalizeDate(date)
  const defaultDateOptions = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }
  dateOptions = Object.assign(dateOptions, defaultDateOptions)
  if (toUTC) date = dateToUTC(date)
  return date.toLocaleDateString('en-CA', dateOptions)
}


const dateToUTC = (date = new Date()) => {
  date = normalizeDate(date)
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  )
}


const dateYMD = (date) => dateToUTC(date).toISOString().split('T')[0]


const monetize = (value, currency = 'CAD') => {
  const number = Number(value)
  if (isNaN(number)) return 'N/A'
  return number.toLocaleString('en-CA', {
    style: 'currency',
    currency: currency,
    maximumFracionDigits: 2
  })
}


const percentize = (value, precision = 2) => {
  const number = Number(value)
  if (isNaN(number)) return 'N/A'
  return number.toFixed(precision) + '%'
}


const niceCount = (count, singular = 'item', plural = 'items') => {
  count = Number(count)
  if (!count) return `No ${plural}`
  count = Math.trunc(count)
  return (count === 1) ? `1 ${singular}` : `${count} ${plural}`
}


const niceJoin = (items = [], separator = ', ', emptyOutput = '') => {
  let cleanItems = compact(items) // Remove wild nulls
  cleanItems = compact(           // Then remove empty values
    cleanItems.map(
      (item) => String(item).trim()
    )
  )
  return isEmpty(cleanItems) ? emptyOutput : cleanItems.join(separator)
}


const wrapText = (text, maxChars = 80) => {
  let output = []
  const lines = text.split("\n")

  lines.forEach((line) => {
    const words = line.split(/\b/)

    let currentLine = ''
    let lastWhite = ''
    words.forEach((word) => {
      let prevLine = currentLine
      currentLine += lastWhite + word

      if (currentLine.length > maxChars) {
        output.push(prevLine.trim())
        currentLine = word
        lastWhite = ''
      }
      else {
        let match = currentLine.match(/(.*)(\s+)$/)
        lastWhite = (match && match.length === 3 && match[2]) || ''
        currentLine = (match && match.length === 3 && match[1]) || currentLine
      }
    })

    output.push(currentLine.trim())
  })

  return output.join("\n")
}


export {
  formatDate,
  dateToUTC,
  dateYMD,
  monetize,
  percentize,
  niceCount,
  niceJoin,
  wrapText
}



// WEBPACK FOOTER //
// ./src/lib/formats.js